import React, { useState, useEffect, useRef } from "react";
import * as XLSX from 'xlsx';
import axios from 'axios';
import "./etl.css";
import { Accordion } from "semantic-ui-react";
import { Icon, Input, Button, Dropdown, Grid, Popup, Segment, Tab, Table, Menu, Form, TextArea, Label, Header, Checkbox } from 'semantic-ui-react'

import Select from "react-select";
import { render } from "@testing-library/react";
// import Modal from 'react-modal';
import Modal from 'react-bootstrap/Modal';

import { GetProcessNames,GetRelationshipNames, GetIdentifierNames, SaveMatchingRules, GetProcessNames1 , GetMatchingRulesAll,GetMatchingRules, GetProcessNames2, GetSourceNames1, Getsourcecolumnnames} from '../../../services/demo/process_data';


const identifier = [
    { value: "1", label: "string" },
    { value: "2", label: "int" },
    { value: "3", label: "special charectors" },
    { value: "4", label: "contains" },
    { value: "5", label: "starts with" },
    { value: "6", label: "ends with" },

];






const MatchingRules = () => {
    const [matchingruleid, setmatchingruleid] = useState();
    const [matchingrule1, setmatchingrule1] = useState('');
    const [rowData, setRowData] = useState([]);
    const [selectdmatchingrule, setselectdmatchingrule] = useState([]);
    const [selectdmatchingruleopions, setselectdmatchingruleoptions] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState();
    const [selectedValues, setSelectedValues] = useState();
    const [selectedOptions1, setSelectedOptions1] = useState();
    const [selectedValues1, setSelectedValues1] = useState();
    const [sourceslist, setsourceslist] = useState([]);
    const [columnslist, setcolumnslist] = useState([]);
    const [columnslist1, setcolumnslist1] = useState([]);
    const [selectedOptions2, setSelectedOptions2] = useState();

    const [getmatchingruleid, setgetmatchingruleid] = useState();

    const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));

    const saveRow = (index, columnName, value) => {
        const updatedData = [...rowData];
        updatedData[index][columnName] = value;
        setRowData(updatedData);

    };

    const identifier1 = [
        { value: "group", label: "group" },
        { value: "sum", label: "sum" },
        { value: "match", label: "match" },
        { value: "notmatch", label: "Notmatch" },
        { value: "notequal", label: "Notequal" },
        { value: "Equal", label: "Equal" },
        { value: "reference", label: "Reference" }
    ];

    const fetchsourcecolumnnames = (value) => {


        let payload = {
            'tenants': userCredentials["tenants_id"],
            'groups': userCredentials["groups_id"],
            'entities': userCredentials["entities_id"],
            'table_name': value,
            'schema_name': selectedValues.label
        }
        console.log('setSelectedValues',selectedValues)
        var FileUploadCredentials = Getsourcecolumnnames();

        axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
            .then(
                response => {
                    console.log("Validate Credentials Response column names!!!", response);
                    // let table_data = response.data;
                    const columnNames = response.data.map(tuple => tuple[0]);
                    console.log('columnNames', columnNames)
                    let names = [];
                    columnNames.map((data) => {

                        let obj = {
                            value: data,
                            label: data
                        }
                        names.push(obj);
                    })
                    setcolumnslist(names);
                }
            )
    }

    const fetchsourcecolumnnames1 = (value) => {


        let payload = {
            'tenants': userCredentials["tenants_id"],
            'groups': userCredentials["groups_id"],
            'entities': userCredentials["entities_id"],
            'table_name': value,
            'schema_name': selectedValues.label
        }

        console.log('payload',payload)

        var FileUploadCredentials = Getsourcecolumnnames();

        axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
            .then(
                response => {
                    console.log("Validate Credentials Response column names!!!", response);
                    const columnNames1 = response.data.map(tuple => tuple[0]);
                    console.log('columnNames', columnNames1)
                    let names = [];
                    columnNames1.map((data1) => {

                        let obj = {
                            value: data1,
                            label: data1
                        }
                        names.push(obj);
                    })
                    setcolumnslist1(names);
                }
            )
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        console.log('name', name, value);
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        if(name === 'source'){
            fetchsourcecolumnnames(value.label);
        }else if(name === 'source2'){
            fetchsourcecolumnnames1(value.label);
        }
        

    };

    const handleAddData = () => {
        // Create a new row object based on the formData state
        const newRow = {
            transaction_type: formData.transaction_type,
            source: formData.source,
            columns: formData.columns,
            source2: formData.source2,
            columns2: formData.columns2,
            actions: formData.actions,
            tolerance: formData.tolerance,

        };

        // Add the new row to the rowData state
        setRowData([...rowData, newRow]);

        // Clear the form fields
        setFormData({
            transaction_type: '',
            source: '',
            columns: '',
            source2: '',
            columns2: '',
            actions: '',
            tolerance: ''

        });
        console.log('rowData', rowData);
    };


    const fetchidentifiertypes = (value) => {


        let payload = {
            'tenants': userCredentials["tenants_id"],
            'groups': userCredentials["groups_id"],
            'entities': userCredentials["entities_id"],
            'process_id': value
        }

        var FileUploadCredentials = GetIdentifierNames();

        axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
            .then(
                response => {
                    console.log("Validate Credentials Response!!!", response);
                    let table_data = response.data;

                    let names = [];
                    table_data.map((data) => {

                        let obj = {
                            value: data,
                            label: data
                        }
                        names.push(obj);
                    })
                    setSelectedOptions1(names);
                }
            )
	.catch(error => {
        console.error("An error occurred:", error);
    })
    }

    const fetchsourcenames = (value) => {

        let payload = {
            // 'tenants': userCredentials["tenants_id"],
            // 'groups': userCredentials["groups_id"],
            // 'entities': userCredentials["entities_id"],
            // 'process_id': value,
            'relationship_id': value
        }
        console.log('payload',payload)
        var FileUploadCredentials = GetRelationshipNames();

        axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
            .then(
                response => {
                    console.log("Validate Credentials Response source names!!!", response);
                    let table_data = response.data;
                    
                    let sources1 = JSON.parse(table_data[0].sources);
                    console.log(sources1);
                    // let sources = [];
                    // sources1.map((sources) => {

                    //     let obj = {
                    //         value: sources.value,
                    //         label: sources.label
                    //     }
                    //     sources.push(obj);
                    // })


                    // console.log(sources)
                    setsourceslist(sources1);
                    // let names = [];
                    // table_data.map((data) => {

                    //     let obj = {
                    //         value: data,
                    //         label: data
                    //     }
                    //     names.push(obj);
                    // })
                    // setSelectedOptions1(names);
                }
            )
    }


    // const handleChange1 = (event) => {
    //     const newValue = event;
    //     console.log('selected val' + newValue);
    //     setSelectedValues(newValue);
    //     fetchidentifiertypes(newValue.value)
    //     fetchsourcenames(newValue.value)
    // }


        const handleChange1 = (event) => {
        const newValue = event;
        console.log('selected val', newValue);
        setSelectedValues(newValue);
        fetchidentifiertypes(newValue.value)
        fetchrelationshipnames(newValue.value)
        fetchmatchingrulesAll(newValue.value);

    }

    const handleChange2 = (event) => {
        const newValue = event;
        console.log('selected val' + newValue);
        setSelectedValues1(newValue);
        fetchsourcenames(newValue.value)

    }

    const fetchprocessnames = () => {
        let payload = {
            File_data: 'hi',
        }

        var FileUploadCredentials = GetProcessNames();

        axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
            .then(
                response => {
                    console.log("Validate Credentials Response!!!", response);
                    let table_data = response.data;

                    let names = [];
                    table_data.map((data) => {

                        let obj = {
                            value: data.primary_id,
                            label: data.process_name
                        }
                        names.push(obj);
                    })
                    setSelectedOptions(names);
                }
            )

    }

    const fetchrelationshipnames = (value) => {

                let payload = {
                    process_id: value
                }
                console.log('payload',payload)
                var FileUploadCredentials = GetRelationshipNames();
        
                axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
                    .then(
                        response => {
                            console.log("Validate Credentials Response!!!", response);
                            let table_data = response.data;
                            let sources = table_data[0].sources;
                            console.log('sources', sources);
                            setsourceslist(JSON.parse(sources));
                            let names = [];
        
                            table_data.map((data) => {
        
                                let obj = {
                                    value: data.relationship_id,
                                    label: data.relationship_name
                                }
                                names.push(obj);
                            })
                            setSelectedOptions2(names);
                        }
                    )
            }

    const fetchmatchingrulesAll = (value) => {
        let payload = {
            process_id: value,
        }

        var FileUploadCredentials = GetMatchingRulesAll();

        axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
            .then(
                response => {
                    console.log("Validate Credentials Response matching all!!!", response);
                    let table_data = response.data;

                    let names = [];
                    table_data.map((data) => {

                        let obj = {
                            value: data.matching_rules_id,
                            label: data.matching_rule_name
                        }
                        names.push(obj);
                    })
                    setselectdmatchingruleoptions(names);
                }
            )

    }

    const [formData, setFormData] = useState({
        transaction_type: '',
        source: '',
        columns: '',
        source2: '',
        columns2: '',
        actions: '',
        tolerance: ''

    });

    // const handleInputChange1 = (e) => {
    //     const { name, value } = e.target;
    //     console.log('name', name, value);
    //     setFormData((prevData) => ({
    //         ...prevData,
    //         [name]: value,
    //     }));

    //     console.log('formData', formData);
    // };

    const SaveMatchingRulesdata = () => {

        let payload = {
            process_id: selectedValues?.value,
            matching_rule_name: matchingrule1,
            relationship_id: selectedValues1?.value,
            matching_rule: rowData,
            tenants_id: userCredentials["tenants_id"],
            groups_id: userCredentials["groups_id"],
            entities_id: userCredentials["entities_id"],
            user_id: userCredentials["user_id"],
           
        }

        var FileUploadCredentials = GetProcessNames1();

        axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
            .then(
                response => {
                    console.log("save matching rule data!!!", response);
                    alert('file config is successfully stored.');
                    window.location.reload();
                }
            ).catch(
                error => {
                    console.log("Error", error);
                    alert("Error in save the config file and source name or source identifier exists already!!!");
                }
            );
    }

    const SaveEditMatchingRulesdata = () => {
        
        let payload = {
            // schema_name: 'process_data',
            // table_name: 'matching_rules',
            // columns_values_dict: {
            //     process_id: selectedValues?.value,
            //     matching_rule_name: matchingrule1,
            //     relationship_id: selectedValues1?.value,
            //     matching_rule: rowData,
            // },
            // condition_column: 'matching_rules_id',
            // condition_value: getmatchingruleid


            process_id: selectedValues?.value,
            matching_rule_name: matchingrule1,
            relationship_id: selectedValues1?.value,
            matching_rule: rowData,
            tenants_id: userCredentials["tenants_id"],
            groups_id: userCredentials["groups_id"],
            entities_id: userCredentials["selectedentity"],
            user_id: userCredentials["user_id"],
            matchingruleid: getmatchingruleid
           
        }

        var FileUploadCredentials = GetProcessNames2();

        axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
            .then(
                response => {
                    console.log("updated matching rule data!!!", response);
                    alert('file config is successfully stored.');

                }
            ).catch(
                error => {
                    console.log("Error", error);
                    alert("Error in save the matching rule data");
                }
            );
    }

const handleSaveData = (event) => {
    console.log('getmatchingruleid', getmatchingruleid)
    if(getmatchingruleid){
        SaveEditMatchingRulesdata();
    }else{
        SaveMatchingRulesdata(); 
    }
    
}

const changeMaching = (event) => {
    setmatchingrule1(event.target.value)
}

const fetchmatchingrules = (event) => {
    let payload = {
        matching_rules_id: event.value,
    }

    var FileUploadCredentials = GetMatchingRules();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response matching!!!", response);
                let data = response.data;
                // let data = data1.data;
                console.log('data', data);
                setgetmatchingruleid(data[0]['matching_rules_id']);
                setmatchingrule1(data[0]['matching_rule_name']);
                setRowData(JSON.parse(data[0]['matching_rule']));
                let val1 = data[0]['process_id']
                fetchidentifiertypes(val1)
                fetchrelationshipnames(val1)
                const objectWithValueOne = selectedOptions.find(item => item.value === val1);
                setSelectedValues(objectWithValueOne);
                setSelectedValues1(objectWithValueOne);
            }
        )
}

const handleChangeNew = (event) => {
    fetchmatchingrules(event)
    setmatchingruleid(event)
}

useEffect(() => {
    fetchprocessnames();
    

}, []);

return (
    <>
        <Grid columns='equal' divided style={{ backgroundColor: "#e9e8d9", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }}>
            <Grid.Row >
                <Grid.Column>
                    <div>
                        <label htmlFor={`startPositionInput`}>Process</label> <br />
                        <Select
                            clearable
                            options={selectedOptions}
                            selection
                            size='mini'
                            onChange={handleChange1}
                            value={selectedValues}

                        />
                    </div>
                </Grid.Column>
                <Grid.Column>
                    <div>
                        <label htmlFor={`endPositionInput`}>matching rule name</label> <br />
                        <Input
                            type="text"
                            style={{ width: '8.5em' }}
                            placeholder="End Position"
                            onChange={changeMaching}
                            value={matchingrule1}
                        />
                    </div>
                </Grid.Column>
                <Grid.Column>
                    <div>
                        <label htmlFor={`startPositionInput`}>Relationship</label> <br />
                        <Select
                            clearable
                            options={selectedOptions2}
                            selection

                            size='mini'
                            onChange={handleChange2}
                            value={selectedValues1}

                        />
                    </div>
                </Grid.Column>
                <Grid.Column>
                    <div>
                        <label htmlFor={`startPositionInput`}>Matching Rule Ids</label> <br />
                        <Select
                            clearable
                            options={selectdmatchingruleopions}
                            selection

                            size='mini'
                            onChange={handleChangeNew}
                            value={matchingruleid}

                        />
                    </div>
                </Grid.Column>
            </Grid.Row>
            {rowData?.map((row, index) => (
                <Grid.Row key={index}>
                    <Grid.Column>
                        <div>
                            <label htmlFor={`startPositionInput${index}`}>Transaction Type</label> <br />
                            <Select
                                clearable
                                options={selectedOptions}
                                selection

                                size='mini'
                                value={row.transaction_type || ''}
                                onChange={(e, { value }) => saveRow(index, 'transaction_type', e)}

                            />
                        </div>
                    </Grid.Column>
                    <Grid.Column>
                        <div>
                            <label htmlFor={`identifierTypeInput${index}`}>Source</label><br />
                            <Select
                                text='Identifier'
                                options={sourceslist}
                                value={row.source || ''}
                                onChange={(e, { value }) => saveRow(index, 'source', e)}

                            />
                        </div>
                    </Grid.Column>
                    <Grid.Column>
                        <div>
                            <label htmlFor={`identifierTypeInput${index}`}>Columns</label><br />
                            <Select
                                text='Identifier'
                                options={columnslist}
                                value={row.columns || ''}
                                onChange={(e, { value }) => saveRow(index, 'columns', e)}

                            />
                        </div>
                    </Grid.Column>
                    <Grid.Column>
                        <div>
                            <label htmlFor={`identifierTypeInput${index}`}>Source 2</label><br />
                            <Select
                                text='Identifier'
                                options={sourceslist}
                                value={row.source2 || ''}
                                onChange={(e, { value }) => saveRow(index, 'source2', e)}

                            />
                        </div>
                    </Grid.Column>
                    <Grid.Column>
                        <div>
                            <label htmlFor={`identifierTypeInput${index}`}>Columns</label><br />
                            <Select
                                text='Identifier'
                                options={columnslist1}
                                value={row.columns2 || ''}
                                onChange={(e, { value }) => saveRow(index, 'columns2', e)}

                            />
                        </div>
                    </Grid.Column>
                    <Grid.Column>
                        <div>
                            <label htmlFor={`identifierTypeInput${index}`}>Actions</label><br />
                            
                            <Select
                                text='Identifier'
                                options={identifier1}
                                value={row.actions || ''}
                                onChange={(e, { value }) => saveRow(index, 'actions', e)}

                            />
                        </div>
                    </Grid.Column>
                    <Grid.Column>
                        <div>
                            <label htmlFor={`endPositionInput${index}`}>Tolerance</label> <br />
                            <Input
                                type="text"
                                style={{ width: '8.5em' }}
                                placeholder="Tolerance"
                                value={row.tolerance || ''}
                                onChange={(e) => saveRow(index, 'tolerance', e.target.value)}

                            />
                        </div>
                    </Grid.Column>

                </Grid.Row>

            ))}

        </Grid>
        <Grid columns='equal' divided style={{ backgroundColor: "#e9e8d9", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }}>
            <Grid.Row>
                <Grid.Column>
                    <div>
                        <label htmlFor="prevValueInput">Transaction type</label><br />
                        <Select text='Identifier'
                            clearable
                            options={selectedOptions1}
                            selection

                            size='mini'
                            value={formData.transaction_type}
                            onChange={(selectedValue) =>
                                handleInputChange({
                                    target: { name: 'transaction_type', value: selectedValue },
                                })
                            }
                        />


                    </div>
                </Grid.Column>
                <Grid.Column>
                    <div>
                        <label htmlFor="prevValueInput">Source</label><br />
                        <Select text='Identifier' options={sourceslist}
                            value={formData.source}
                            onChange={(selectedValue) =>
                                handleInputChange({
                                    target: { name: 'source', value: selectedValue },
                                })
                            }
                        />
                    </div>
                </Grid.Column>
                <Grid.Column>
                    <div>
                        <label htmlFor="prevValueInput">Columns</label><br />
                        <Select text='Identifier' options={columnslist}
                            value={formData.columns}
                            onChange={(selectedValue) =>
                                handleInputChange({
                                    target: { name: 'columns', value: selectedValue },
                                })
                            }
                        />
                    </div>
                </Grid.Column>

                <Grid.Column>
                    <div>
                        <label htmlFor="prevValueInput">Source 2</label><br />
                        <Select text='Identifier' options={sourceslist}
                            value={formData.source2}
                            onChange={(selectedValue) =>
                                handleInputChange({
                                    target: { name: 'source2', value: selectedValue },
                                })
                            }
                        />
                    </div>
                </Grid.Column>
                <Grid.Column>
                    <div>
                        <label htmlFor="prevValueInput">Columns</label><br />
                        <Select text='Identifier' options={columnslist1}
                            value={formData.columns2}
                            onChange={(selectedValue) =>
                                handleInputChange({
                                    target: { name: 'columns2', value: selectedValue },
                                })
                            }
                        />
                    </div>
                </Grid.Column>
                <Grid.Column>
                    <div>
                        <label htmlFor="prevValueInput">Actions</label><br />
                        <Select text='Identifier' options={identifier1}
                            value={formData.actions}
                            onChange={(selectedValue) =>
                                handleInputChange({
                                    target: { name: 'actions', value: selectedValue },
                                })
                            }
                        />
                    </div>
                </Grid.Column>
                <Grid.Column>
                    <div>
                        <label htmlFor="prevValueInput">Tolerance </label> <br />
                        <Input type="integer" style={{ width: '8.5em' }} placeholder="Length" name="tolerance" value={formData.tolerance} onChange={handleInputChange} />
                    </div>
                </Grid.Column>
            </Grid.Row>


            <Grid.Row>
                <Grid.Column></Grid.Column>
                <Grid.Column></Grid.Column>
                <Grid.Column></Grid.Column>
                <Grid.Column>
                    <button style={{ height: "35px", width: "92px", backgroundColor: "#000055", color: "#ffffff", marginLeft: '2em' }} onClick={handleAddData}>+</button>
                </Grid.Column>
                <Grid.Column>
                    <button style={{ height: "35px", width: "92px", backgroundColor: "#000055", color: "#ffffff", marginLeft: '2em' }} onClick={handleSaveData}>Save</button>
                </Grid.Column>
            </Grid.Row>

        </Grid>
    </>
)
}

export default MatchingRules;


